<template>
  <modal
    :show.sync="isOpenLocal"
    scrollable
    header-classes="bg-primary p-2 flex items-center"
    @close="handleClose"
  >
    <h6 slot="header" class="modal-title text-white pl-4 font-semibold">
      Add News
    </h6>
    <div class="pb-8 customboxed">
      <p>News Link</p>
      <base-input
        alternative
        class="mb-3"
        name="Title"
        :rules="{ required: true }"
        placeholder="Add your news link"
        v-model="title"
      >
      </base-input>
    </div>
    <template slot="footer">
      <base-button type="primary" class="">Add</base-button>
    </template>
  </modal>
</template>
<script>
import "../../../scss/Index.scss";
export default {
  props: {
    isOpen: Boolean,
  },
  computed: {
    isOpenLocal: {
      get() {
        return this.isOpen;
      },
      set(val) {
        if (!val) {
          this.handleClose();
        }
      },
    },
  },
  data() {
    return {
      title: "",
    };
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>
